if (!customElements.get('product-card-media-slider')) {
  customElements.define(
    'product-card-media-slider',
    class ProductCardMediaSlider extends HTMLElement {
      connectedCallback() {
        this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mql.onchange = this.onViewportChange.bind(this);

        this.sliderEl = this.querySelector('[data-pcard-media-slider]');
        if (!this.sliderEl) return;

        const wrapper = this.sliderEl.querySelector('.swiper-wrapper');
        const slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
        if (!slides || slides.length < 2) return;

        this.onViewportChange();
      }

      onViewportChange() {
        const isMobile = this.mql?.matches ?? FoxTheme.config.mqlMobile;
        if (isMobile) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }
      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          threshold: 2,
          initialSlide: 0,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.sliderEl, this.sliderOptions);
        this.sliderInstance.init();
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}
